const Option = () => null;
Option.isSelectOption = true;
Option.displayName = 'AAutoCompleteOption';
export default Option;
